import { render, staticRenderFns } from "./AttendanceGovernanceOverview.vue?vue&type=template&id=bf6be6d0&scoped=true"
import script from "./AttendanceGovernanceOverview.vue?vue&type=script&lang=js"
export * from "./AttendanceGovernanceOverview.vue?vue&type=script&lang=js"
import style0 from "./AttendanceGovernanceOverview.vue?vue&type=style&index=0&id=bf6be6d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6be6d0",
  null
  
)

export default component.exports